import React from 'react';
import BlogPage from './blog';

const BlogPageEn = (): React.ReactElement => {
  return <BlogPage lang="en"></BlogPage>;
};

export default BlogPageEn;
